import React, { useState } from 'react'
import './LoginPage.css'
import backgroundImage from '../../Assets/background4.jpg'
import hostelLogo from '../../Assets/logo.png'
import { useNavigate } from 'react-router-dom'
import {
  ResetPassword,
  SendUserOtp,
  StudentLoginAPI,
} from '../../AllAPI/StudentAPI'
import { toast } from 'react-toastify'
import axios from 'axios'
import { Modal } from 'antd'
import { VscActivateBreakpoints } from 'react-icons/vsc'
import { AiFillBuild } from 'react-icons/ai'

export default function StudentLoginPage({ onLogin }) {
  const navigate = useNavigate()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [approvalModal, setApprovalModal] = useState(false)

  const [forgotModal, setForgotModal] = useState(false)
  const [otpModal, setOtpModal] = useState(false)

  const [fpEmail, setFpEmail] = useState('')
  const [fpOtp, setFpOtp] = useState('')
  const [fpNewPass, setFpNewPass] = useState('')
  const [fpConfirmPass, setFpConfirmPass] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!username || !password) {
      toast.error('Please enter username and password')
      return
    }

    try {
      setLoading(true)

      const objData = {
        email: username,
        password: password,
      }

      const response = await axios.post(StudentLoginAPI, objData)

      const data = response.data

      if (data == 'INVALID') {
        toast.warn('Invalid credentials!')
      } else if (data == 'NOTFOUND') {
        toast.warn('Data Not Found!')
      } else if (data != null) {
        // ⭐ STATUS CONDITIONS ⭐
        if (data.status === 0) {
          // Not paid hostel fee
          navigate('/student/std-hostelPay')
        } else if (data.status === 1) {
          // Admin approval pending
          // Show Modal Instead of Navigation
          setApprovalModal(true)
        } else if (data.status === 2) {
          // Approved Student
          toast.success('Login successful')
          navigate('/student/std-dashboard')
        } else if (data.status === 3) {
          // Rejected hostel fee
          navigate('/student/std-hostelPay')
        }

        sessionStorage.setItem('studentData', JSON.stringify(data))
        sessionStorage.setItem('username', 'student')
        onLogin('student')
      }
    } catch (error) {
      toast.error('Something went wrong!')
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  // SEND OTP
  const sendOtpHandler = async () => {
    if (!fpEmail) {
      toast.error('Please enter email!')
      return
    }

    try {
      setLoading1(true)

      const response = await axios.post(SendUserOtp, { email: fpEmail })

      if (response.data === 'SENDOTP') {
        toast.success('OTP sent successfully!')
        setForgotModal(false)
        setOtpModal(true)
      } else if (response.data === 'NOTFOUND') {
        toast.error('Email not found!')
      }
    } catch (err) {
      toast.error('Failed to send OTP')
    } finally {
      setLoading1(false)
    }
  }

  // VERIFY OTP + RESET PASSWORD
  const verifyOtpHandler = async () => {
    if (!fpOtp || !fpNewPass) {
      toast.error('All fields are required!')
      return
    }

    try {
      setLoading2(true)

      const response = await axios.post(ResetPassword, {
        email: fpEmail,
        otp: fpOtp,
        newPassword: fpNewPass,
      })

      if (response.data === 'PASSWORDCHANGED') {
        toast.success('Password reset successfully!')
        setOtpModal(false)
      } else if (response.data === 'INVALIDOTP') {
        toast.warn('Invalid OTP!')
      } else if (response.data === 'EXPIRYOTP') {
        toast.warn('OTP has been expired!')
      } else if (response.data === 'NOTFOUND') {
        toast.warn('Member not found!')
      } else {
        toast.error('Invalid OTP or error resetting password!')
      }
    } catch (err) {
      toast.error('Something went wrong!')
    } finally {
      setLoading2(false)
    }
  }

  return (
    <div
      className="login-background"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="row m-0">
        {/* TOP LEFT HEADER */}
        <div className="col-12">
          {/* <div className="d-flex align-items-center">
            <img src={hostelLogo} alt="Hostel Logo" className="hostel-logo" />
            <h1 className="hostel-name pt-2 pt-md-0">Manikbag Digambar Jain Boarding</h1>
          </div> */}
          <div className="row m-0 p-0 align-items-center">
            <div className="col-3 col-md-2 col-xl-1 p-0">
              <img
                src={hostelLogo}
                alt="Company Logo"
                className="footer-logo"
              />
            </div>
            <div className="col-9 col-md-10 col-xl-11 p-md-0">
              <h6 style={{ color: '#eb3337' }}>
                {' '}
                Dakshin Bharat Jain Sabha's{' '}
              </h6>
              <h3
                style={{ textShadow: '1px 1px 2px #eb3337' }}
                className="company-name"
              >
                {' '}
                MANIKBAG DIGAMBAR JAIN BOARDING{' '}
              </h3>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="col-12 py-md-5">
          <div className="row p-3">
            <div className="col-12 col-md-6 col-xl-8"></div>
            <div className="col-12 col-md-6 col-xl-4 py-md-3 px-md-5">
              <div className="login-form-container">
                <div className="login-box">
                  <h2 className="login-title">Student Login</h2>
                  <form onSubmit={handleSubmit}>
                    <div className="input-group1">
                      <label>Username</label>
                      <input
                        type="text"
                        placeholder="Enter Email Id"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        style={{ borderRadius: '4px' }}
                      />
                    </div>

                    <div className="input-group1">
                      <label>Password</label>
                      <input
                        type="password"
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={{ borderRadius: '4px' }}
                      />
                    </div>

                    <button
                      type="submit"
                      className="login-btn"
                      disabled={loading}
                    >
                      {loading ? 'Logging in...' : 'Login'}
                    </button>
                  </form>

                  {/* ✅ New User Registration Button */}
                  <button
                    className="register-btn"
                    onClick={() => navigate('/student/register')}
                  >
                    New User? Register Here
                  </button>

                  {/* ✅ Forgot Password Button */}
                  <button
                    className="forgot-btn"
                    onClick={() => setForgotModal(true)}
                    style={{
                      marginTop: '10px',
                      color: '#fff',
                      background: 'transparent',
                      border: 'none',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    Forgot Password?
                  </button>

                  {/* <div className="bottom-links">
                <span>
                  &copy; 2025 Jain Boarding | Managed By: TechnoAarv Solution.
                </span>
              </div> */}
                </div>

                <Modal
                  title={
                    <span
                      style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        color: '#235784',
                      }}
                    >
                      Waiting for Admin Approval <br />
                      <span style={{ fontSize: '15px' }}>
                        {' '}
                        (ನಿರ್ವಾಹಕರ ಅನುಮೋದನೆಗಾಗಿ ನಿರೀಕ್ಷಿಸಲಾಗುತ್ತಿದೆ)
                      </span>
                    </span>
                  }
                  className="approval-modal"
                  open={approvalModal}
                  onOk={() => setApprovalModal(false)}
                  okText="OK"
                  closable={false}
                  cancelButtonProps={{ style: { display: 'none' } }}
                >
                  <p style={{ fontSize: '18px' }}>
                    Your registration is under verification.
                    <span style={{ color: 'gray' }}>
                      (ನಿಮ್ಮ ನೋಂದಣಿ ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ.)
                    </span>
                  </p>
                  <p style={{ fontSize: '18px' }}>
                    Please wait until admin approves your account.
                    <span style={{ color: 'gray' }}>
                      (ದಯವಿಟ್ಟು ನಿರ್ವಾಹಕರು ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಅನುಮೋದಿಸುವವರೆಗೆ
                      ಕಾಯಿರಿ.)
                    </span>
                  </p>
                </Modal>

                {/* ================== FORGOT PASSWORD – EMAIL MODAL ================== */}
                <Modal
                  title={
                    <span
                      style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#235784',
                      }}
                    >
                      Forgot Password
                    </span>
                  }
                  open={forgotModal}
                  onCancel={() => setForgotModal(false)}
                  footer={null}
                >
                  <label style={{ fontSize: '16px' }}>
                    Enter Registered Email
                  </label>
                  <input
                    type="email"
                    value={fpEmail}
                    onChange={(e) => setFpEmail(e.target.value)}
                    placeholder="Enter email"
                    className="form-control"
                    style={{ marginTop: '8px', borderRadius: '6px' }}
                  />

                  <button
                    className="login-btn"
                    style={{ width: '100%', marginTop: '15px' }}
                    onClick={sendOtpHandler}
                    disabled={loading1}
                  >
                    {loading1 ? 'Wait...' : 'Send OTP'}
                  </button>
                </Modal>

                {/* ================== OTP + NEW PASSWORD MODAL ================== */}
                <Modal
                  title={
                    <span
                      style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#235784',
                      }}
                    >
                      Reset Password
                    </span>
                  }
                  open={otpModal}
                  onCancel={() => setOtpModal(false)}
                  footer={null}
                >
                  <label style={{ fontSize: '16px' }}>Enter OTP</label>
                  <input
                    type="text"
                    className="form-control"
                    value={fpOtp}
                    onChange={(e) => setFpOtp(e.target.value)}
                    placeholder="Enter OTP"
                    style={{
                      marginBottom: '10px',
                      marginTop: '5px',
                      borderRadius: '6px',
                    }}
                  />

                  <label style={{ fontSize: '16px' }}>New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={fpNewPass}
                    onChange={(e) => setFpNewPass(e.target.value)}
                    placeholder="New Password"
                    style={{
                      marginBottom: '10px',
                      marginTop: '5px',
                      borderRadius: '6px',
                    }}
                  />

                  <button
                    className="login-btn"
                    style={{ width: '100%', marginTop: '15px' }}
                    onClick={verifyOtpHandler}
                  >
                    {loading2 ? 'Wait...' : 'Reset Password'}
                  </button>
                </Modal>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="col-12">
          <footer className="footer row px-2 px-md-5">
            <div className="row m-0 p-0 footer-container">
              {/* LEFT */}
              <div className="col-12 col-md-6 footer-left">
                <div className="row m-0 p-0">
                  <div className="col-4 col-md-3 p-0">
                    <img
                      src={hostelLogo}
                      alt="Company Logo"
                      className="footer-logo"
                    />
                  </div>
                  <div className="col-8 col-md-9 p-0">
                    <h6 style={{ color: '#eb3337' }}>
                      {' '}
                      Dakshin Bharat Jain Sabha's{' '}
                    </h6>
                    <h3
                      style={{ textShadow: '1px 1px 2px #eb3337' }}
                      className="company-name"
                    >
                      {' '}
                      MANIKBAG DIGAMBAR JAIN BOARDING{' '}
                    </h3>
                  </div>
                </div>
              </div>

              {/* CENTER */}
              <div className="col-12 col-md-3 mt-3 mt-md-0 footer-center">
                <span
                  onClick={() => navigate('/terms')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Terms & Conditions
                </span>
                <span
                  onClick={() => navigate('/privacy')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Privacy Policy
                </span>
                <span
                  onClick={() => navigate('/admin/login')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Admin Login
                </span>
                <span
                  onClick={() => navigate('/office/login')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Office Login
                </span>
              </div>

              {/* RIGHT */}
              <div className="col-12 col-md-3 mt-3 mt-md-0 footer-right">
                <h6 className="text-white pb-2">
                  Dakshin Bharat Jain Sabha's Manikbag Digambar Jain Boarding
                </h6>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} /> Email: &nbsp;{' '}
                  <span>mdjbbelgavi@gmail.com</span>
                </p>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} /> Phone: &nbsp;{' '}
                  <span>7022691008 , 9480448108</span>
                </p>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} /> Address: &nbsp;
                  Opposite Manikbag Automobiles, Old P.B Road, Belagavi
                  Karnataka 590016
                </p>
              </div>
            </div>

            <div className="footer-bottom">
              © 2025 MANIKBAG DIGAMBAR JAIN BOARDING | Managed By TechnoAarv
              Solution
            </div>
          </footer>
        </div>
      </div>
    </div>
  )
}
